var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#d6ab55",
    height: "22px",
    width: "14px",
    id: "XMLID_5_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M13,23V13h3.4l0.5-4H13V6.6c0-1.1,0.3-1.9,1.9-1.9H17V1.2c-0.4,0-1.6-0.2-3-0.2c-3,0-5,1.8-5,5.2V9H5.6v4H9v10 C9,23,13,23,13,23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.9582b6d8de59724cb4dce13ee0378298.svg";
export { ForwardRef as ReactComponent };